<template>
  <div></div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { handleCallback } from '../authentication'

export default defineComponent({
  name: 'CallbackHandler',
  setup() {
    onMounted(async () => {
      try {
        console.log('Handling callback...')
        await handleCallback()
        console.log('Callback handled successfully.')
      } catch (error) {
        console.error('Error handling callback:', error)
      }
    })
  }
})
</script>
